<!--
//================================================================================
// ID:BC013C1
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC013C1
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2023/04/20 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
  <main class="contents__main">
	<div class="contents__main--mosikomi" />
	<error-message />
	<!--◆編集エリア START◆-->
	<div id="ichiran">
		<p></p><hr>
		<div style="margin-bottom: 8px; margin-top: 15px;">
			<span>ファイル名</span>
			<b><span class="contents__hissu1" style="margin-left: 5px;">必須</span></b>
			<file-upload
				:name="'ファイル名'"
				:clickUploadOrSaveBtn="clickUploadOrSaveBtn"
				:requireFlg="true"
				:fileExtensions="['csv']"
				:fileAcceptExtensions="['.csv']"
				:fileSize="200"
				:messageType="'CSVファイル'"
				:uploadBtnFlg="true"
				:groupId="'fileUploadInfo'"
				:placeholder="'ファイルを選択してください。'"
				ref="fileUpload"
				style="display: inline;"
				tabindex="1"
			>
			</file-upload>
			<itemerror-message :groupId="'fileUploadInfo'"/>
		</div>
		<p></p><hr>
		<br />
		<h2 class="contents__h2">取込み結果一覧</h2>
		<div align="center">
			<table border="1" class="contents__table--itiran" id="list">
				<thead>
					<tr id="listheader">
						<th id="meisaititle1">取込み日</th>
						<th id="meisaititle2">ファイル名</th>
						<th id="meisaititle3">取込み件数</th>
						<th id="meisaititle4">結果</th>
					</tr>
				</thead>
				<tbody>
					<tr id="meisaienen" v-on:click="clickMeisai(row)" v-for="row in form.meisaiList" :key="row.dtTorikomi">
						<td id="meisaidtTorikomi">{{ co_editDate(row.dtTorikomi) }}</td>
						<td id="meisaitxFileName" class="contents__kaigyo--css">{{ row.txFileName }}</td>
						<td id="meisainuKensu">{{ co_commaSeparated(row.nuKensu) }}</td>
						<td id="meisainmResult">{{ row.nmResult }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<!--◆編集エリア END◆-->
  </main>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

import { STORE_VIEW_PROGRESS, STORE_ERROR_CLEAR, STORE_ERROR_IS_ERRFLG, STORE_DATA_ADD_DATA } from '@/const/store.js';
import { co_post } from '@/common/ajaxUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_commaSeparated, co_editDate } from '@/common/stringUtility.js';
import { DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { co_postFile } from '@/common/ajaxUtility.js';
import { co_confirmDialog } from '@/common/dialogUtility.js';
import { co_toTrans } from '@/common/screenUtility.js';

import { PATH_BC013_TORIKOMI, PATH_BC013_SEARCH } from '@/const/route.js';

export default {
	name: "BC013C1",
	components: {
		'error-message': ErrorMessage,
		'itemerror-message': ItemErrorMessage,
		'file-upload': FileUpload
	},
	data: function () {
		return {
			form: {
				txFileName: '',
				txFilePath: '',
				meisaiList:[],
			},
			co_commaSeparated: co_commaSeparated,
			co_editDate: co_editDate,
		}
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		this.$refs.fileUpload.focus();
	},
	// 初期表示
	created: function() {
		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);
		
		this.form.meisaiList = this.meisaiList;

		// 検索処理実施
		this.search();

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
    
	},
	methods: {
		// 検索処理
		search: async function() {

			// プログレスバーを表示
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let list = await co_post(PATH_BC013_SEARCH, this.form);
			if(list.meisaiList === null || list.meisaiList.length === 0){

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				return;
			}

			let edintList = [];
			for (let i = 0; i < list.meisaiList.length; i++) {
				edintList.push({
					dtTorikomi: list.meisaiList[i].dtTorikomi,
					txFileName: list.meisaiList[i].txFileName,
					nuKensu: list.meisaiList[i].nuKensu,
					nmResult: list.meisaiList[i].nmResult,
					txFilePath: list.meisaiList[i].txFilePath,
					nuRenban: list.meisaiList[i].nuRenban
				});
			}
			this.form.meisaiList = edintList;

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, {id:'BC013C1', data:this.form});

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

		},
		// 「取込」ボタン押下イベント
		clickUploadOrSaveBtn: async function() {		

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// エラー情報をクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 画面項目をチェック
			this.$refs.fileUpload.validate();

			// 入力チェックでエラーがない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {

				// 確認ダイアログ表示
				co_confirmDialog(co_getMessage('W0026'), this.doUpload);
			}

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

		},
		// 取込処理
		doUpload: async function(flg) {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 確認ダイアログの「はい」を押下の場合
			if(flg == DIALOG_BUTTON_LIST_KEY.OK){

				// プログレスバーを表示
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				//ファイルアップロード用のFormDataを作成して、取得
				this.$refs.fileUpload.createFormData('fileUpload');

				//FormDataに画面の入力内容を設定
				let formData = this.$refs.fileUpload.getFormData();

				// ファイルアップロード
				let result = await co_postFile(PATH_BC013_TORIKOMI, formData);

				// 取込元ファイルをクリア
				this.$refs.fileUpload.clearSelectedFile();

				// プログレスバーを非表示
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 取込み結果画面遷移
				let params = {
								dtTorikomi : result.meisaiList[0].dtTorikomi, 
								nuRenban : result.meisaiList[0].nuRenban,
								txFileName : result.meisaiList[0].txFileName,
								txFilePath : result.meisaiList[0].txFilePath
							};
				co_toTrans('BC013C2', params);

			}

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);
		},
		// 明細押下
		clickMeisai: function (row) {

			let params = {
							dtTorikomi : row.dtTorikomi, 
							nuRenban : row.nuRenban,
							txFileName : row.txFileName,
							txFilePath : row.txFilePath
						};
			co_toTrans('BC013C2', params);

		}
	}
}
</script>

<style scoped>

/*PAGE START*/
#ichiran {
	margin: 8px;
}
#link {
	text-decoration: none;
}
#list{
	width: 100%;
}
#list tbody tr:nth-child(even) td, #list tbody tr:nth-child(even) th {
    background-color: #eeeeee;
}
#list tbody tr:hover td, #list tbody tr:hover th {
    background-color: #fff5d5;
}
#meisaititle1{
	width: 20%;
}
#meisaititle2{
	width: 60%;
}
#meisaititle3{
	width: 10%;
}
#meisaititle4{
	width: 10%;
}
#meisaidtTorikomi{
	text-align: center;
}
#meisaitxFileName{
	padding-left: 1%;
}
#meisainuKensu{
	text-align: center;
}
#meisainmResult{
	text-align: center;
}
th,td{
	padding-top: 1%;
	padding-bottom: 1%;
}
.contents__hissu1 {
	background-color: #fe0000;
	color: #ffffff;
	font-size: 12px;
	border-radius: 3px;
	padding : 2px 2px;
	margin-right: 20px;
	margin-bottom: 2px;
	position: relative;
	bottom: 2px;
}
.active {
    border-color: #47acec;
    background-color: #6dbcee;
    color: #fff;
}
/*PAGE END*/

</style>
